import React, { CSSProperties, FC } from "react";

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  justifyContent?: CSSProperties["justifyContent"];
  alignItems?: CSSProperties["alignItems"];
  flex?: CSSProperties["flex"];
  flexDirection?: CSSProperties["flexDirection"];
}

const Flex: FC<Props> = ({
  justifyContent = "initial",
  alignItems = "initial",
  flex = "initial",
  flexDirection = "initial",
  children,
  style,
  ...props
}) => (
  <div style={{ alignItems, display: "flex", flex, flexDirection, justifyContent, ...style }} {...props}>
    {children}
  </div>
);

export default Flex;
